import { Controller } from "react-hook-form";
import MapsSelectHook from "../../maps/MapsSelectHook";
import { formatAddress } from "../../../utils/helpers/logicHelper";
import FieldHelp from "../FieldHelp";


const ADDRESS = ({ divClass, inputClass, formControl, formHook, initialValue, showHelp, helpText }) => {
  const shouldShowHelp = showHelp && helpText;
  const helpId = `field-help-${formControl["key"]}`;
  
  return (
    <div className={`${divClass} ${shouldShowHelp ? "field-with-help" : ""}`.trim()}>
      <label className="tx-14 d-block" htmlFor={formControl.key}>
        {formControl.label}
        {/* {formControl.required && <span className="text-danger">*</span>} */}
      </label>

      <div className="field-input-wrap">
        <Controller
          name={formControl.key}
          control={formHook.control}
          defaultValue={formatAddress(initialValue) || ""}
          // rules={{
          //   required: formControl.required
          //     ? `${formControl.label} is required`
          //     : false
          // }}
          render={({ field }) => (
            <MapsSelectHook
              placeholder={formControl.placeholder || "Enter address"}
              label={null}
              setInitialValue={initialValue}
              setLocation={(locationObj) => {
                field.onChange(locationObj.address);
              }}
              setError={(err) => console.log(err)}
              className={inputClass}
              value={field.value}
              onInputChange={field.onChange}
            />
          )}
        />
        {shouldShowHelp && <FieldHelp id={helpId} text={helpText} />}
      </div>
    </div>
  );
};

export default ADDRESS;
